import { CustomElement } from '@aurelia/runtime-html';
export const name = "e5-dropdown";
export const template = "<dialog role=\"dropdown\" id.bind=\"id\" class=\"top-16 p-5 ${isSmall ? 'min-w-[200px]' : 'min-w-[350px]'} cursor-default\" click.trigger=\"stopEventAllowDefault($event)\" e-toggle.trigger=\"toggle()\">\r\n    <form if.bind=\"displayCloseButton\" class=\"pb-4 flex justify-end\" click.trigger=\"close()\">\r\n        <button title=\"Close\" class=\"size-15 flex justify-center items-center text-blue-800 rounded-full bg-blue-100 hover:bg-blue-300\">\r\n            <svg class=\"w-8 h-8 stroke-current\">\r\n                <use href.bind=\"RESOURCE_BASE_URL + '/images/icons_sprite.svg#est-cross-light'\"></use>\r\n            </svg>\r\n        </button>\r\n    </form>\r\n    <au-slot></au-slot>\r\n</dialog>";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
